import { create } from "zustand";
import type { CustomSound, GameSoundKey } from "@spieleparadies/shared";

interface CustomSoundsState {
  sounds: Record<string, CustomSound>;
  /** Komplette Liste vom Server übernehmen (z. B. beim Beitritt) */
  setAll: (sounds: CustomSound[]) => void;
  /** Einen Sound einfügen/überschreiben */
  upsert: (sound: CustomSound) => void;
  /** Sound entfernen */
  remove: (key: GameSoundKey) => void;
  /** Alle Sounds löschen (z. B. beim Verlassen des Raums) */
  clear: () => void;
  get: (key: GameSoundKey) => CustomSound | undefined;
}

/**
 * Hält die für den aktuellen Raum hinterlegten Sprachaufnahmen.
 * Inhalt kommt vom Server – kein Local-Storage, beim Raum-Wechsel weg.
 */
export const useCustomSoundsStore = create<CustomSoundsState>((set, get) => ({
  sounds: {},
  setAll: (list) =>
    set({
      sounds: Object.fromEntries(list.map((s) => [s.key, s])),
    }),
  upsert: (sound) =>
    set((state) => ({
      sounds: { ...state.sounds, [sound.key]: sound },
    })),
  remove: (key) =>
    set((state) => {
      const next = { ...state.sounds };
      delete next[key];
      return { sounds: next };
    }),
  clear: () => set({ sounds: {} }),
  get: (key) => get().sounds[key],
}));
